<template>
    <div class="m-calendar__header">
        <calendar-toggle></calendar-toggle>
        <div class="m-calendar__week">
            <span class="m-calendar__dayname" v-for="date in dates" v-html="date.format('dd')"></span>
        </div>
        <div class="m-calendar__days">
            <div class="m-calendar__group" v-for="date in dates">
                <button :disabled="checkDate(date)" class="m-calendar__button r-button"
                        :class="{'m-calendar__button_selected': chosenDate.format('DDMMYY') === date.format('DDMMYY')}"
                        @click="setChosenDate(date)"
                        v-html="date.format('DD')">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
	import {mapGetters, mapActions, mapState, mapMutations} from 'vuex';
	import CalendarToggle from "../CalendarToggle";

    import dayjs from 'dayjs';

    export default {
		name: 'CalendarMobileHeader',
        components: {CalendarToggle},
		computed: {
			...mapGetters([
				'dates',
			]),
			...mapState([
			    'vetId',
				'dateNow',
				'userTimeZone',
				'chosenDate',
                'firstAppointmentDate',
                'appointments'
			]),
        },
        data() {
		    return {
                settedAppointments: []
            }
        },
        watch: {
            appointments(appointments){
                this.settedAppointments = appointments;
            },
            firstAppointmentDate(date) {
                date.diff(this.dateNow, 'days') >= 6
                    ? this.setStartDate(date)
                    : this.setChosenDate(date);
            }
        },
        mounted() {
            this.getFirstAppointmentDate();
        },
        methods: {
			...mapMutations([
				'setChosenDate',
                'setStartDate',
                'setActiveTimePeriod'
            ]),
            ...mapActions([
                'getFirstAppointmentDate'
            ]),
            checkDate(date){
			    let disabledDate = true;
			    let currentDate = this.dateNow;

			    this.settedAppointments.forEach((appointment) => {
                    if (appointment.start_at.format('DDMMYY') === date.format('DDMMYY')){
                        if (appointment.start_at.isAfter(currentDate)) {
                            if (!appointment.consultation) {
                                return disabledDate = false;
                            }
                        }
                    }
                });

                return disabledDate;
            }
		},
    }
</script>
